import React, { FormEvent, Fragment } from 'react';

import { PrimaryButton, DefaultButton, SelectableOptionMenuItemType, Toggle } from 'office-ui-fabric-react';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Dialog, DialogType, DialogFooter, IDialogStyles } from 'office-ui-fabric-react/lib/Dialog';
import { Dropdown, IDropdownOption, IDropdownStyles } from 'office-ui-fabric-react/lib/Dropdown';

import { EgTestScenarioEntity, EgUserEntity } from '../../../data';
import { EgApplicationVersion } from '../../../../../core/src/interfaces';
import { Loading } from '..';

import './NewTest.scss';

const defaultFields = {
  automaticallyApproved: false,
  name: '',
  domainName: 'egms.dev',
  organizationalUnit: 'OU=Windows10,OU=Workstations,OU=Machines,OU=Evergreen,DC=EGMS,DC=DEV',
  serviceAccount: 'EGMS\\evg-rdp-admin',
  servicePassword: '',
  testCommand: 'vstest.console.exe Avanade.Testing.7zip.dll /Logger:trx /Platform:x86',
  startCommand: ''
};

class NewTest extends React.Component<any, any> {

  constructor(props: any) {
    super(props);

    this.state = {
      actions: [],
      application: null,
      users: [],
      versions: [],
      showPanel: false,
      hideDialog: true,
      choice: 'A',
      step: 1,
      fields: defaultFields,
      errors: {},
      formName: '',
      formVersion: { key: this.props.application.currentVersion ? this.props.application.currentVersion.id : 0, text: '' },
      formOwner: { key: 12, text: 'Maris Balodis' },
      selectedFile: null,
      inProgress: false
    };

    this.loadData();
  }

  async loadData () {
    const users: EgUserEntity[] = await EgUserEntity.all();
    const versions: EgApplicationVersion[] = await this.props.application.getVersions();
    this.setState({
      users: users,
      versions: versions
    });
  }

  ActionMenu = (props: { placeholder: string, options: any }) => {
    return (
      <Dropdown
        options={props.options}
        placeholder={props.placeholder}
      />
    );
  }

  TestScenarioList = (props: { testScenarios: EgTestScenarioEntity[] }) => {
    if (props.testScenarios && props.testScenarios.length > 0) {
      const listItems = props.testScenarios.map((testScenario: EgTestScenarioEntity) => {
        return (
          <tr key={testScenario.id}>
            <td>{testScenario.name}</td>
            <td>{testScenario.version ? testScenario.version.number : '-'}</td>
            <td>{testScenario.owner ? testScenario.owner.name : '-'}</td>
            <td>
              <Toggle onChange={(ev, checked) => this.handleToggle(ev, checked, testScenario)} onText="Automatically" offText="Manually" checked={testScenario.automaticallyApproved} />
            </td>
          </tr>
        );
      });

      return (
        <div className="eg-test-scenarios">
          <table className="table is-fullwidth">
            <thead>
              <tr>
                <th>Name</th>
                <th>Version</th>
                <th>Owner</th>
                <th>Approval</th>
              </tr>
            </thead>
            <tbody>
              {listItems}
            </tbody>
          </table>
        </div>
      );
    } else {
      return (
        <p>There are no Test Scenarios created yet!</p>
      );
    }
  }

  render() {

    const versionOptions: IDropdownOption[] = this.state.versions.map((version: EgApplicationVersion) => {
      return {
        key: version.id,
        text: this.props.application.currentVersion && this.props.application.currentVersion.number == version.number ? `${version.number} (current)` : version.number
      }
    });
    versionOptions.unshift({ key:  0, text: 'Choose Application Version' });

    const userOptions: IDropdownOption[] = this.state.users.map((user: EgUserEntity) => {
      return {
        key: user.id,
        text: user.name
      }
    });
    userOptions.unshift({ key:  0, text: 'Choose Owner' });

    return (
      <div className="eg-no-test-cases">

        <this.TestScenarioList testScenarios={this.props.application.testScenarios} />

        <PrimaryButton iconProps={{ iconName: 'Add' }} onClick={this.openDialog}>New Test Scenario</PrimaryButton>

        <Dialog
          hidden={this.state.hideDialog}
          onDismiss={this.closeDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: 'New Test Scenario'
          }}
          modalProps={{
            isBlocking: true,
            styles: {
              // main: { maxWidth: 700 }
            }
          }}
          className="eg-new-test-case-dialog"
        >
          <div className="eg-new-test-case">
            { this.state.step === 1 &&
              <Fragment>
                <div className="field">
                  <label className="label">What would you like to do:</label>
                  <div className="control">
                    <ChoiceGroup
                      className="defaultChoiceGroup"
                      options={[
                        {
                          key: 'A',
                          text: 'Create new test scenario using automated test script'
                        },
                        {
                          key: 'B',
                          text: 'Create new test scenario using manual test approach'
                        },
                        {
                          key: 'H',
                          text: 'Help me do this'
                        }
                      ]}
                      onChange={this._onChange}
                      selectedKey={this.state.choice}
                      required={true}
                    />
                  </div>
                </div>
                <div className="field">
                  If you need assistance creating automated test script for this application - our team will can help you with automating application testing.
                </div>
              </Fragment>
            }

            { this.state.step === 2 && !this.state.inProgress &&
              <Fragment>
                <div className="field">
                  <label className="label">Test Scenario Name</label>
                  <div className="control">
                    <input className="input" type="text" name="name" value={this.state.fields['name']} onChange={this.handleTextChange} placeholder="Enter Name" />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Version</label>
                  <div className="control">
                    <Dropdown
                      onChange={this._onVersionChange}
                      options={versionOptions}
                      placeholder="Choose Application Version"
                      selectedKey={this.state.formVersion ? this.state.formVersion.key : 0}
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Owner</label>
                  <div className="control">
                    <Dropdown
                      onChange={this._onOwnerChange}
                      options={userOptions}
                      placeholder="Choose User"
                      selectedKey={this.state.formOwner ? this.state.formOwner.key : 0}
                      errorMessage={this.state.errors.owner ? 'please fill in this field' : undefined}
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Domain Name</label>
                  <div className="control">
                    <input className="input" type="text" name="domainName" value={this.state.fields['domainName']} onChange={this.handleTextChange} placeholder="Enter Domain" />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Organizational Unit</label>
                  <div className="control">
                    <input className="input" type="text" name="organizationalUnit" value={this.state.fields['organizationalUnit']} onChange={this.handleTextChange} placeholder="Enter Domain" />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Service Account</label>
                  <div className="control">
                    <input className="input" type="text" name="serviceAccount" value={this.state.fields['serviceAccount']} onChange={this.handleTextChange} placeholder="Enter Account" />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Service Password</label>
                  <div className="control">
                    <input className="input" type="password" name="servicePassword" value={this.state.fields['servicePassword']} onChange={this.handleTextChange} placeholder="Enter Password" autoComplete="off" />
                  </div>
                </div>
                { this.state.choice == 'A' &&
                  <Fragment>
                    <div className="field">
                      <label className="label">Test Approval</label>
                      <div className="control">
                          {/* <Checkbox
                            checked={this.isChecked('automaticallyApproved')}
                            onChange={(e) => this.handleCheck(e, 'automaticallyApproved')}
                            label="Automatically Approved"
                          /> */}
                          <Toggle
                            onChange={(ev, checked) => this.handleToggleCheck(ev, checked, 'automaticallyApproved')}
                            onText="Automatically"
                            offText="Manually"
                            checked={this.isChecked('automaticallyApproved')}
                          />
                      </div>
                    </div>
                    <div className="field">
                      <label className="label">Test Script</label>
                      <div className="control">
                        <div className="file has-name">
                          <label className="file-label">
                            <input className="file-input" type="file" name="selectedFile" onChange={this.onFileChange} />
                            <span className="file-cta">
                              <span className="file-icon">
                                <i className="fas fa-upload"></i>
                              </span>
                              <span className="file-label">
                                Choose a file...
                              </span>
                            </span>
                            <span className="file-name">
                              { this.state.selectedFile ? this.state.selectedFile.name : '.zip' }
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="field">
                      <label className="label">Test Command</label>
                      <div className="control">
                        <input className="input" type="text" name="testCommand" value={this.state.fields['testCommand']} onChange={this.handleTextChange} placeholder="Provide Test Command" />
                      </div>
                    </div>
                    <div className="field">
                      <label className="label">Start Command</label>
                      <div className="control">
                        <input className="input" type="text" name="startCommand" value={this.state.fields['startCommand']} onChange={this.handleTextChange} placeholder="Provide Application Start Command" />
                      </div>
                    </div>
                  </Fragment>
                }
              </Fragment>
            }
          </div>
          <DialogFooter className="eg-new-test-scenario-footer">
            { this.state.inProgress && <Loading /> }
            { !this.state.inProgress &&
              <Fragment>
                <DefaultButton onClick={this.closeDialog} text="Cancel" />
                { this.state.step > 1 && <DefaultButton onClick={this.backStep} text="Back" />}
                { this.state.step === 1 && <PrimaryButton onClick={this.nextStep} text="Continue" /> }
                { this.state.step === 2 &&<PrimaryButton onClick={this.createTestScenario} text="Create" /> }
              </Fragment>
            }
          </DialogFooter>
        </Dialog>
      </div>
    );
  }

  isChecked = (fieldName: string) => {
    return this.state.fields[fieldName];
  }

  handleToggle = async (event: any, checked: boolean | undefined, testScenario: EgTestScenarioEntity) => {
    console.log(checked, testScenario);
    await EgTestScenarioEntity.setAutomaticallyApproved(testScenario, checked);
    this.props.loadData(this.props.application.id);
  }

  handleToggleCheck = async (event: any, checked: boolean | undefined, fieldName: string) => {
    const fields = {...this.state.fields, [fieldName]: checked};
    this.setState({
      fields: fields
    });
  }

  // handleCheck = async (event: any, fieldName: string) => {
  //   const fields = {...this.state.fields, [fieldName]: event.target.checked};
  //   this.setState({
  //     fields: fields
  //   });
  // }

  onFileChange = (e: any) => {
    this.setState({ selectedFile: e.target.files[0] });
  }

  setValidationError = (fieldName: string) => {
    const errors = {...this.state.fields, [fieldName]: true};
    this.setState({
      errors: errors
    });
  }

  unsetValidationError = (fieldName: string) => {
    const errors = {...this.state.fields, [fieldName]: false};
    this.setState({
      errors: errors
    });
  }

  handleTextChange = (event: any) => {
    const fields = {...this.state.fields, [event.target.name]: event.target.value};
    this.setState({
      fields: fields
    });
  }

  createTestScenario = async (event: any) => {
    event.preventDefault();

    // if (this.state.formOwner.key === 0) {
    //   this.setValidationError('owner');
    // }

    if (this.state.fields.name.length > 0 && this.state.formVersion.key > 0 && this.state.formOwner.key > 0) {

      await this.setState({
        inProgress: true
      });

      const testScenario = await EgTestScenarioEntity.create(this.props.application.id,
                                                             this.state.fields,
                                                             this.state.formVersion.key,
                                                             this.state.formOwner.key,
                                                             this.state.selectedFile);

      this.props.loadData(this.props.application.id);

      this.closeDialog(event);      
    }
  }




  _onVersionChange = (event: FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
    this.setState({ formVersion: option });
  }

  _onOwnerChange = (event: FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
    this.setState({ formOwner: option });
    if (option && option.key > 0) {
      this.unsetValidationError('owner');
    } else {
      this.setValidationError('owner');
    }
  }





  backStep = (event: any) => {
    this.setState({
      step: this.state.step - 1
    });
  };

  nextStep = (event: any) => {
    if (this.state.choice == 'H') {
      this.closeDialog(undefined);
    } else {
      this.setState({
        step: this.state.step + 1
      });
    }
  };

  

  openDialog = (event: any) => {
    this.setState({
      hideDialog: false,
      choice: 'A',
      step: 1,
      fields: defaultFields,
      errors: {},
      formName: '',
      formVersion: { key: this.props.application.currentVersion ? this.props.application.currentVersion.id : 0, text: '' },
      formOwner: { key: 12, text: 'Maris Balodis' },
      selectedFile: null,
      inProgress: false
    });
  };

  closeDialog = (event: any) => {
    this.setState({
      hideDialog: true
    });
  };

  _onChange = async (ev?: FormEvent<HTMLInputElement | HTMLElement> | undefined, option?: IChoiceGroupOption | undefined) => {
    if (option) {
      await this.setState({
        choice: option.key
      });

      console.log(this.state.choice);
    }
  };
}

export {
  NewTest
};
